import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppFloat from './WhatsAppFloat';
import CustomCursor from './CustomCursor';

const PageShell = ({ children }) => (
  <div className="App bg-cream dark:bg-dark-bg transition-colors duration-500 min-h-screen">
    <CustomCursor />
    <Navbar />
    <main>{children}</main>
    <Footer />
    <WhatsAppFloat />
  </div>
);

export default PageShell;
